/* ============================================================
   ILEV · CARRITO — un solo archivo  (11-sep-2026)
   ------------------------------------------------------------
   Reemplaza a cuatro archivos que se cargaban por separado
   (ilev-carrito-config.js · component-shipping-notice.js ·
   ilev-carrito-layout.js · ilev-carrito-abrir.js) y trae la lógica
   del pop-up de regalo y del carrito del home, que antes iban
   escritas dentro del HTML de cada página.

   Partes (cada una se activa sola si su pieza está en la página):
     1. BUS DEL CARRITO: una sola petición a /cart.js por cambio, que
        reciben todas las partes. Antes cada una pedía la suya: 5 al
        cargar una ficha y 3 por cada "Añadir".
     2. CONFIGURACIÓN  ⭐ acá se cambian montos, textos y la regla de
        venta cruzada. Precio, foto, stock y reseñas NO se escriben:
        los trae Shopify (snippets/ilev-carrito-carga.liquid).
     3. BARRA DE METAS + VENTA CRUZADA + SELLOS (panel y página /cart).
     4. PANEL: abrir y cerrar el carrito lateral (clic fuera, Escape,
        X) y paleta clara si el fondo de la barra es oscuro.
     5. POP-UP DE REGALO (desde el 28-sep: shampoo 30 g sobre $130.000).
     6. CARRITO EN EL HOME ("Confirma tu pedido").
     7. BURBUJA del carrito en el encabezado (número de productos).

   Estilos: assets/ilev-carrito.css (panel y /cart) ·
   assets/ilev-regalo.css (pop-up y líneas de regalo; desde el 28-sep
   reemplaza a ilev-carrito-aniversario.css, que vestía el carrito de cobalto) ·
   assets/ilev-carrito-home.css. Ya no se inyecta CSS desde JS.

   Lo cargan snippets/ilev-carrito-carga.liquid, el pop-up de regalo
   y la sección del home. Si aparece más de una vez en la página,
   solo la primera copia hace algo.
   Respaldo de los archivos anteriores:
   04-WEB/CODIGO-ANIVERSARIO/_optimizacion-2026-09-11/originales/
   ============================================================ */
(function () {
  'use strict';
  if (window.ILEV_CARRITO_CARGADO) return;
  window.ILEV_CARRITO_CARGADO = true;

  /* =========================================================
     1. BUS DEL CARRITO
     ========================================================= */
  var RUTAS = /\/cart\/(add|change|update|clear)(\.js)?/;
  var ES_ADD = /\/cart\/add(\.js)?/;
  var fetch0 = window.fetch;
  var ultimo = null, tUltimo = 0, enVuelo = null;
  var espera = null, timer = null, huboAdd = false;
  var oyentes = [];

  function pedir() {
    var p = fetch0.call(window, '/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { ultimo = c; tUltimo = Date.now(); if (enVuelo === p) enVuelo = null; return c; },
            function (e) { if (enVuelo === p) enVuelo = null; throw e; });
    enVuelo = p;
    return p;
  }

  function avisar(c, info) {
    for (var i = 0; i < oyentes.length; i++) { try { oyentes[i](c, info); } catch (e) {} }
  }

  /* Hubo un cambio: se esperan 300 ms por si vienen más seguidos y se
     pide el carrito UNA vez para todos. */
  function marcar(esAdd) {
    if (esAdd) huboAdd = true;
    if (!espera) {
      var res;
      espera = { p: new Promise(function (r) { res = r; }) };
      espera.res = res;
    }
    clearTimeout(timer);
    timer = setTimeout(function () {
      var e = espera, info = { add: huboAdd };
      espera = null; huboAdd = false;
      pedir().then(function (c) { e.res(c); avisar(c, info); },
                   function () { e.res(ultimo); });
    }, 300);
  }

  /* Un solo interceptor para toda la página (antes había tres apilados). */
  window.fetch = function () {
    var u = arguments[0];
    var ruta = (typeof u === 'string') ? u : (u && u.url) || '';
    var p = fetch0.apply(this, arguments);
    if (RUTAS.test(ruta)) {
      var add = ES_ADD.test(ruta);
      p.then(function () { marcar(add); }, function () {});
    }
    return p;
  };

  var open0 = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (metodo, url) {
    if (RUTAS.test(url || '')) {
      var add = ES_ADD.test(url);
      this.addEventListener('load', function () { marcar(add); });
    }
    return open0.apply(this, arguments);
  };

  /* Avisos del tema y de apps. Si ya se pidió el carrito recién, no se
     repite. */
  function porEvento() {
    if (enVuelo || espera || Date.now() - tUltimo < 1500) return;
    marcar(false);
  }
  ['cart-updated', 'cart:updated', 'cart:refresh'].forEach(function (n) {
    document.addEventListener(n, porEvento, true);
  });

  var BUS = {
    get: function () {
      if (espera) return espera.p;
      if (enVuelo) return enVuelo;
      if (ultimo && Date.now() - tUltimo < 2000) return Promise.resolve(ultimo);
      return pedir();
    },
    on: function (fn) { oyentes.push(fn); },
    refresh: function () { marcar(false); return espera.p; }
  };
  window.ILEV_CART = BUS;

  /* =========================================================
     2. CONFIGURACIÓN  ⭐
     28-sep-2026 · Fin del aniversario, reglas evergreen (Franco):
       $60.000  → envío gratis (13-sep-2026: bajado desde $75.000)
       $130.000 → shampoo 30 g de regalo, anticaspa o anticaída (pop-up, parte 5)
     El hito del regalo lo cumple el pop-up + el descuento automático
     de los regalos. El del envío, el descuento automático de envío
     gratis de Shopify, que TIENE que estar en $60.000.
     ========================================================= */
  window.ILEV_ACTIVO = true;

  window.ILEV_IDS = {
    duo:     44077689536693,
    tonico:  42481091084469,
    bomba:   43620701995189,
    shampoo: 44971738235061,
    barba:   45474721726645,
    serum:   42480528785589,
    /* "demás productos activos": los packs de 3 meses (van siempre al final) */
    duo3:      44793312968885,
    trio:      45326264598709,
    trioSerum: 51804261646517,
    trioBarba: 51804280783029
  };

  /* REGLA DE VENTA CRUZADA (10-sep, tres casos). Recibe tiene(id) y
     devuelve los ids a sugerir, EN ORDEN.
       BASE   → aún no tiene la rutina: rutina + shampoo + extras
       CASO 1 → tiene DÚO (o Tónico + Bomba) y NO el shampoo: shampoo
       CASO 2 → tiene la rutina Y el shampoo: Barba + Sérum */
  window.ILEV_REGLA = function (tiene, ID) {
    var duo = tiene(ID.duo);
    var ton = tiene(ID.tonico);
    var bom = tiene(ID.bomba);
    var sha = tiene(ID.shampoo);
    var rutina = duo || (ton && bom);
    var out = [];
    if (rutina) {
      if (!sha) out.push(ID.shampoo);
    } else {
      if (ton)      out.push(ID.bomba, ID.duo);
      else if (bom) out.push(ID.tonico, ID.duo);
      else          out.push(ID.duo, ID.tonico, ID.bomba);
      if (!sha) out.push(ID.shampoo);
    }
    out.push(ID.barba, ID.serum);
    out.push(ID.duo3, ID.trio, ID.trioSerum, ID.trioBarba);
    return out.filter(function (id) { return !tiene(id); });
  };

  /* Título del bloque, según el mismo caso. */
  window.ILEV_TITULO = function (tiene, ID) {
    var rutina = tiene(ID.duo) || (tiene(ID.tonico) && tiene(ID.bomba));
    if (!rutina) return 'El 82% de los clientes mejora sus resultados con:';
    if (!tiene(ID.shampoo)) return 'Potencia tu rutina capilar con:';
    return 'Completa el kit ILEV:';
  };

  window.ILEV_CFG = {
    /* umbral de envío gratis: la venta cruzada marca "+ Envío gratis"
       en la tarjeta que cruza el monto. Igual al descuento de Shopify. */
    umbral: 60000,

    /* METAS DE LA BARRA (en orden de monto). Claves: monto · n · i · falta
       Íconos: 'truck', 'gift', 'cake' (torta), 'regalo' (cajita)
       ⚠ el nombre (n) CORTO: va en una línea junto al monto. */
    hitos: [
      {
        monto: 60000,
        n: 'Envío gratis',
        i: 'truck',
        falta: 'Te faltan <strong>{x}</strong> para conseguir el <strong>envío gratis</strong>!'
      },
      {
        monto: 130000,
        n: 'Shampoo gratis',
        i: 'regalo',
        falta: 'Te faltan <strong>{x}</strong> para llevarte un <strong>shampoo de regalo</strong> 🎁'
      }
    ],

    txtFalta:   'Te faltan <strong>{x}</strong> para conseguir el <strong>envío gratis</strong>!',
    txtVacio:   'Suma tu rutina y consigue el <strong>envío gratis</strong>',
    txtLogrado: '¡Conseguiste el <strong>envío gratis</strong>!',
    txtTodo:    '¡Desbloqueaste todo: <strong>envío gratis + shampoo de regalo</strong>! 🎁',

    /* respaldo si ILEV_TITULO no existiera */
    tituloConDato:  'El 82% de los clientes mejora sus resultados con:',
    tituloGenerico: 'El 82% de los clientes mejora sus resultados con:',
    txtTarjeta:     '+ Envío gratis',

    extrasAuto: false,     /* el orden de los extras lo pone ILEV_REGLA */
    minResenas: 5,         /* reseñas Loox: se muestran desde esta cantidad */

    trust: [
      { i: 'truck', t: 'Envío gratis $60.000' },
      { i: 'shield', t: 'Garantía de 90 días' },
      { i: 'lock', t: 'Pago 100% seguro' }
    ],

    /* Solo el NOMBRE corto de cada tarjeta. Precio, foto, stock y
       reseñas vienen de Shopify (window.ILEV_CATALOGO). Un producto que
       no esté publicado o no tenga precio no se sugiere. */
    productos: {
      44077689536693: { n: 'DUO Anticaida - Tonico + Bomba' },
      42481091084469: { n: 'Tonico Anticaida' },
      43620701995189: { n: 'Bomba Nutricional' },
      44971738235061: { n: 'Shampoo Anticaida en barra 70 g' }
    },
    extras: [
      { id: 45474721726645, n: 'Tonico de Barba' },
      { id: 42480528785589, n: 'Serum Antiquiebre' },
      { id: 44793312968885, n: 'DUO Anticaida - 3 meses' },
      { id: 45326264598709, n: 'TRIO 90 dias - Tonico + Bomba + Shampoo' },
      { id: 51804261646517, n: 'TRIO 90 dias + Serum de regalo' },
      { id: 51804280783029, n: 'TRIO 90 dias + Tonico de Barba de regalo' }
    ]
  };

  /* datos vivos de Shopify sobre la config */
  (function () {
    var C = window.ILEV_CATALOGO;
    if (!C) return;
    function mezclar(o, id) {
      var c = C[id];
      if (!c) return;
      if (c.p) o.p = c.p;
      if (c.img) o.img = c.img;
      o.hay = c.hay;
      if (c.nr) { o.r = c.r; o.nr = c.nr; }
    }
    Object.keys(window.ILEV_CFG.productos).forEach(function (id) { mezclar(window.ILEV_CFG.productos[id], id); });
    window.ILEV_CFG.extras.forEach(function (e) { mezclar(e, e.id); });
  })();

  /* la parte 4 la define si hay panel; la parte 3 la llama al pintar */
  var adaptarFondo = null;

  /* =========================================================
     3. BARRA DE METAS + VENTA CRUZADA + SELLOS
     ========================================================= */
  function iniciarBarra() {
    if (!window.ILEV_CARRITO_BARRA || !window.ILEV_ACTIVO) return;
    var CFG = window.ILEV_CFG, IDS = window.ILEV_IDS;
    var CDN = 'https://cdn.shopify.com/s/files/1/0619/8296/5941/files/';

    var ICON = {
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M1 3h13v13H1zM14 8h4l3 3v5h-7z"/><circle cx="5.5" cy="18.5" r="2"/><circle cx="17.5" cy="18.5" r="2"/></svg>',
      gift: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M5 12v8a1 1 0 001 1h12a1 1 0 001-1v-8M12 8v13"/><path d="M12 8S10.5 3.5 8 3.5A2.2 2.2 0 008 8zM12 8s1.5-4.5 4-4.5A2.2 2.2 0 0116 8z"/></svg>',
      cake: '<span class="ilev-hito__emoji" aria-hidden="true">🎂</span>',
      regalo: '<span class="ilev-hito__emoji" aria-hidden="true">🎁</span>',
      check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5.5 5.5L20 7"/></svg>',
      shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5z"/></svg>',
      lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 018 0v3"/></svg>',
      prev: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>',
      next: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>'
    };

    function pesos(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }
    function miles(v) { return '$' + v.toLocaleString('es-CL'); }

    /* la línea GRATIS del regalo del pop-up no suma a las metas:
       se miden sobre lo que la clienta paga */
    function subBase(c) {
      var s = c.items_subtotal_price;
      (c.items || []).forEach(function (it) {
        var p = it.properties || {};
        if (p._regalo_aniversario) s -= it.final_line_price;
      });
      return Math.max(0, s);
    }

    function agregar(id, boton) {
      if (boton) { boton.disabled = true; boton.classList.add('ilev-add--load'); }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function () {
        /* el bus repinta la barra solo; esto repinta la lista del tema */
        if (typeof window.refreshCart === 'function') window.refreshCart();
        else location.reload();
      }).catch(function () {
        if (boton) { boton.disabled = false; boton.classList.remove('ilev-add--load'); }
      });
    }

    /* ---------- BARRA CON HITOS ---------- */
    function hitos() {
      var H = CFG.hitos;
      return (H && H.length) ? H
        : [{ monto: CFG.umbral, n: 'Envío gratis', i: 'truck', falta: CFG.txtFalta }];
    }

    function htmlBarra(c) {
      var H = hitos(), n = H.length, sub = subBase(c);
      var pos = [], i;
      for (i = 0; i < n; i++) pos.push(((i + 0.5) / n) * 100);

      var fill = 100, sig = -1;
      for (i = 0; i < n; i++) {
        var m = H[i].monto * 100;
        if (sub < m) {
          var mAnt = i === 0 ? 0 : H[i - 1].monto * 100;
          var pAnt = i === 0 ? 0 : pos[i - 1];
          var t = (m - mAnt) > 0 ? (sub - mAnt) / (m - mAnt) : 1;
          t = Math.max(0, Math.min(1, t));
          fill = pAnt + (pos[i] - pAnt) * t;
          sig = i;
          break;
        }
      }

      var todo = sig === -1, txt;
      if (todo) txt = CFG.txtTodo || CFG.txtLogrado;
      else if (sub === 0 && sig === 0) txt = CFG.txtVacio;
      else txt = (H[sig].falta || CFG.txtFalta).replace('{x}', pesos(H[sig].monto * 100 - sub));

      /* con la barra vacía se deja un mínimo visible: cero desanima */
      var ancho = todo ? 100 : Math.max(4, fill);

      var h = '<div class="ilev-prog ilev-prog--h" data-sub="' + sub + '">' +
                '<p class="ilev-prog__txt">' + txt + '</p>' +
                '<div class="ilev-hitos">' +
                  '<div class="ilev-hitos__riel"><span class="ilev-hitos__fill" style="width:' + ancho.toFixed(1) + '%"></span></div>';

      /* cada meta conserva SIEMPRE su ícono; "logrado" = círculo relleno */
      H.forEach(function (m, i) {
        var listo = sub >= m.monto * 100;
        h += '<div class="ilev-hito' + (listo ? ' ilev-hito--on' : '') + '" style="left:' + pos[i].toFixed(1) + '%">' +
               '<span class="ilev-hito__ico">' + (ICON[m.i] || ICON.truck) + '</span>' +
               '<span class="ilev-hito__n">' + m.n + '</span>' +
               '<span class="ilev-hito__p">' + miles(m.monto) + '</span>' +
             '</div>';
      });

      return h + '</div></div>';
    }

    /* ---------- VENTA CRUZADA ---------- */
    function estrellas(s) {
      var min = CFG.minResenas || 5;
      if (!s.nr || s.nr < min || !s.r) return '';
      var llenas = Math.round(s.r);
      var h = '<span class="ilev-card__stars">';
      for (var i = 1; i <= 5; i++) h += '<span class="' + (i <= llenas ? 'on' : '') + '">★</span>';
      return h + '<span class="ilev-card__nr">(' + s.nr + ')</span></span>';
    }

    function elegirSugerencias(ids) {
      var tiene = function (id) { return ids.indexOf(id) !== -1; };
      var lista = window.ILEV_REGLA(tiene, IDS) || [];
      var extras = CFG.extras || [];
      function extra(id) {
        for (var i = 0; i < extras.length; i++) if (extras[i].id === id) return extras[i];
        return null;
      }
      var out = [];
      lista.forEach(function (id) {
        var p = CFG.productos[id];
        if (p) out.push({ id: id, n: p.n, p: p.p, r: p.r, nr: p.nr, img: p.img, hay: p.hay });
        else { var e = extra(id); if (e) out.push(e); }
      });
      if (CFG.extrasAuto !== false) {
        extras.forEach(function (e) {
          if (!tiene(e.id) && lista.indexOf(e.id) === -1) out.push(e);
        });
      }
      /* lo agotado o sin precio (no publicado) no se sugiere */
      return out.filter(function (s) { return s.hay !== false && s.p > 0; });
    }

    function htmlSug(c) {
      var U = CFG.umbral * 100;
      var sub = subBase(c);
      var ok = (U - sub) <= 0;

      var ids = c.items.map(function (i) { return i.variant_id; });
      var libres = elegirSugerencias(ids);
      if (!libres.length) return '';

      var titulo;
      if (typeof window.ILEV_TITULO === 'function') {
        titulo = window.ILEV_TITULO(function (id) { return ids.indexOf(id) !== -1; }, IDS);
      } else {
        var conDato = [IDS.duo, IDS.tonico, IDS.bomba];
        var aplicaDato = libres.slice(0, 3).some(function (s) { return conDato.indexOf(s.id) !== -1; });
        titulo = aplicaDato ? CFG.tituloConDato : CFG.tituloGenerico;
      }

      var h = '<p class="ilev-sug__tit">' + titulo + '</p>' +
              '<div class="ilev-sug__wrap">' +
                '<button type="button" class="ilev-arrow ilev-arrow--prev ilev-arrow--off" id="ilev-prev" aria-label="Anterior">' + ICON.prev + '</button>' +
                '<div class="ilev-sug__lista" id="ilev-slider">';
      libres.forEach(function (s) {
        var cruza = !ok && (sub + s.p * 100) >= U;
        /* la foto viene como URL completa (Shopify) o nombre de archivo */
        var src = s.img ? (/^(https?:)?\/\//.test(s.img) ? s.img : CDN + s.img) : '';
        var img = src ? '<img src="' + src + '" alt="" loading="lazy">'
                      : '<span class="ilev-card__ph">ILEV</span>';
        h += '<div class="ilev-card">' +
               '<div class="ilev-card__img">' + img + '</div>' +
               '<div class="ilev-card__info">' + estrellas(s) +
                 '<span class="ilev-card__n">' + s.n + '</span>' +
                 '<span class="ilev-card__p">' + miles(s.p) + '</span>' +
                 (cruza ? '<span class="ilev-card__ok">' + CFG.txtTarjeta + '</span>' : '') +
               '</div>' +
               '<button type="button" class="ilev-add" data-v="' + s.id + '" aria-label="Agregar ' + s.n + '">+</button>' +
             '</div>';
      });
      return h + '</div><button type="button" class="ilev-arrow ilev-arrow--next" id="ilev-next" aria-label="Siguiente">' + ICON.next + '</button></div>';
    }

    /* Sellos bajo el botón de pago. 11-sep: solo se mueve si NO es ya el
       último hijo. Antes se reinsertaba siempre, eso disparaba el
       observador y el ciclo se repetía cada 250 ms sin parar. */
    function trust() {
      var pie = document.querySelector('#site-cart-sidebar .sidebar__footer');
      if (!pie) return;
      var ya = document.getElementById('ilev-trust');
      if (ya) {
        if (ya.parentNode !== pie || pie.lastElementChild !== ya) pie.appendChild(ya);
        return;
      }
      var d = document.createElement('div');
      d.id = 'ilev-trust'; d.className = 'ilev-trust';
      var h = '';
      (CFG.trust || []).forEach(function (b) { h += '<span class="ilev-trust__i">' + (ICON[b.i] || '') + b.t + '</span>'; });
      d.innerHTML = h;
      pie.appendChild(d);
    }

    function enlazar(caja, nItems) {
      var bs = caja.querySelectorAll('.ilev-add');
      for (var i = 0; i < bs.length; i++) {
        bs[i].addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          agregar(Number(this.dataset.v), this);
        });
      }
      var slider = caja.querySelector('#ilev-slider');
      if (!slider) return;
      slider.style.setProperty('--ilev-card-w', nItems <= 1 ? '58%' : '78%');

      var prev = caja.querySelector('#ilev-prev'), next = caja.querySelector('#ilev-next');
      function paso() { var c1 = slider.children[0]; return c1 ? c1.getBoundingClientRect().width + 8 : 200; }
      function flechas() {
        var hay = slider.scrollWidth > slider.clientWidth + 4;
        if (prev) prev.classList.toggle('ilev-arrow--off', slider.scrollLeft <= 4 || !hay);
        if (next) next.classList.toggle('ilev-arrow--off', slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 4 || !hay);
      }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); slider.scrollBy({ left: -paso(), behavior: 'smooth' }); setTimeout(flechas, 350); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); slider.scrollBy({ left: paso(), behavior: 'smooth' }); setTimeout(flechas, 350); });
      slider.addEventListener('scroll', flechas, { passive: true });
      setTimeout(flechas, 100);
      window.addEventListener('resize', flechas);
    }

    function pintar(c) {
      if (!c) return;
      var cf = document.querySelector('cart-form');

      var barra = document.querySelector('shipping-notice');
      if (!barra && cf) {
        barra = document.createElement('shipping-notice');
        barra.className = 'cart-notice';
        cf.insertBefore(barra, cf.firstChild);
      }
      if (barra) {
        var dentro = barra.querySelector('.ilev-prog--h');
        if (!dentro || dentro.dataset.sub !== String(subBase(c))) {
          barra.innerHTML = htmlBarra(c);
        }
      }

      var sug = document.getElementById('ilev-sug');
      if (!sug && cf && cf.parentNode) {
        sug = document.createElement('div');
        sug.id = 'ilev-sug'; sug.className = 'ilev-sug';
        cf.parentNode.insertBefore(sug, cf.nextSibling);
      }
      if (sug) {
        var contenido = htmlSug(c);
        sug.innerHTML = contenido;
        sug.style.display = contenido ? '' : 'none';
        if (contenido) enlazar(sug, c.items.length);
      }

      trust();
      if (adaptarFondo) adaptarFondo();
    }

    function refrescar() { BUS.get().then(pintar).catch(function () {}); }

    /* el tema RECREA <shipping-notice> al actualizar el carrito */
    if (typeof customElements.get('shipping-notice') === 'undefined') {
      customElements.define('shipping-notice', class extends HTMLElement {
        connectedCallback() { setTimeout(refrescar, 60); }
      });
    }

    BUS.on(function (c) { pintar(c); });
    refrescar();

    /* el tema repinta el panel entero: se reponen los sellos. Solo se
       observa el panel, no toda la página. */
    var panel = document.getElementById('site-cart-sidebar');
    if (panel && 'MutationObserver' in window) {
      var tSellos;
      new MutationObserver(function () {
        clearTimeout(tSellos);
        tSellos = setTimeout(trust, 250);
      }).observe(panel, { childList: true, subtree: true });
    }
  }

  /* =========================================================
     4. PANEL LATERAL
     ========================================================= */
  function iniciarPanel() {
    if (!window.ILEV_CARRITO_PANEL) return;

    function panel() { return document.getElementById('site-cart-sidebar'); }

    /* show() y hide() del tema dan por hecho dos cosas que solo prepara
       <main-header>, desactivado en este tema: la lista de elementos a
       inertar y un elemento con aria-controls del panel. */
    function preparar() {
      if (!window.inertElems) window.inertElems = document.querySelectorAll('[data-js-inert]');
      if (!document.querySelector('[aria-controls="site-cart-sidebar"]')) {
        var h = document.createElement('span');
        h.setAttribute('aria-controls', 'site-cart-sidebar');
        h.hidden = true;
        document.body.appendChild(h);
      }
    }

    function abrir(enlace) {
      var d = panel();
      if (!d || typeof d.show !== 'function') return false;
      preparar();
      if (enlace) {
        enlace.setAttribute('aria-controls', 'site-cart-sidebar');
        enlace.setAttribute('aria-expanded', 'true');
      }
      d.show();
      return true;
    }

    function estaAbierto() {
      var d = panel();
      return !!d && (d.classList.contains('sidebar--opened') || document.body.classList.contains('sidebar-opened'));
    }

    /* cierre a prueba de fallos: primero hide() del tema; si revienta,
       se repiten sus pasos a mano */
    function cerrar() {
      var d = panel();
      if (!d || !estaAbierto()) return;
      preparar();
      try {
        d.hide();
      } catch (e) {
        d.opened = false;
        d.classList.remove('sidebar--opened');
        document.body.classList.remove('sidebar-opened', 'sidebar-opened--left', 'sidebar-opened--right');
        Array.prototype.forEach.call(window.inertElems || [], function (elm) { elm.removeAttribute('inert'); });
        setTimeout(function () { if (!estaAbierto()) d.style.display = 'none'; }, 501);
      }
    }

    /* abrir desde el ícono del header (un <a href="/cart"> normal) */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="/cart"], a[href$="/cart"]');
      if (!a) return;
      if (a.closest('#site-cart-sidebar')) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (abrir(a)) e.preventDefault();
    }, true);

    /* cerrar: clic fuera (overlay), la X, tecla Escape */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.site-overlay')) { cerrar(); return; }
      if (e.target.closest('#site-cart-sidebar [data-js-close]')) { e.preventDefault(); cerrar(); }
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && estaAbierto()) cerrar();
    });

    preparar();
    window.ILEV_CARRITO = { abrir: function () { return abrir(null); }, cerrar: cerrar };

    /* Si el tema pinta la barra sobre fondo oscuro, la barra pasa a
       paleta clara. 11-sep: se revisa al pintar la barra, ya no 60 veces
       cada 100 ms al cargar la página. */
    var TEXTO = '#4B384C';
    function luz(rgb) {
      var m = (rgb || '').match(/[0-9.]+/g);
      if (!m || m.length < 3) return 1;
      if (m[3] !== undefined && parseFloat(m[3]) === 0) return 1;
      return (0.299 * m[0] + 0.587 * m[1] + 0.114 * m[2]) / 255;
    }
    adaptarFondo = function () {
      var n = document.querySelector('shipping-notice');
      if (!n) return false;
      if (document.getElementById('ilev-layout-oscuro')) return true;
      var bg = getComputedStyle(n).backgroundColor;
      var m = (bg || '').match(/[0-9.]+/g);
      if (!m || (m[3] !== undefined && parseFloat(m[3]) === 0)) return false;
      if (luz(bg) > 0.55) return true;
      var d = document.createElement('style');
      d.id = 'ilev-layout-oscuro';
      d.textContent =
        '.ilev-prog__txt,.ilev-prog__txt strong{color:#fff!important}' +
        '.ilev-hito__n,.ilev-hito__p{color:rgba(255,255,255,.72)!important}' +
        '.ilev-hito--on .ilev-hito__n,.ilev-hito--on .ilev-hito__p{color:#fff!important}' +
        '.ilev-hitos__riel{background:rgba(255,255,255,.20)!important}' +
        '.ilev-hitos__fill{background:#fff!important}' +
        '.ilev-hito__ico{background:rgba(255,255,255,.16)!important;' +
          'color:rgba(255,255,255,.55)!important;box-shadow:0 0 0 3px ' + bg + '!important}' +
        '.ilev-hito--on .ilev-hito__ico{background:#fff!important;color:' + TEXTO + '!important}';
      document.head.appendChild(d);
      return true;
    };
    adaptarFondo();
  }

  /* =========================================================
     5. POP-UP DE REGALO (desde el 28-sep: shampoo 30 g sobre $130.000)
     Datos (umbral y regalos) en snippets/ilev-regalo-aniversario.liquid.
     El umbral se mide sobre lo que la clienta PAGA: total del carrito
     con escalera y códigos del carrito, menos lo que valga el regalo.
     ========================================================= */
  function iniciarRegalo() {
    var datos = document.getElementById('ilev-regalo-datos');
    var modal = document.getElementById('ilevRegaloModal');
    if (!datos || !modal) return;
    var D;
    try { D = JSON.parse(datos.textContent); } catch (e) { return; }
    var UMBRAL = D.umbral;
    var REGALOS = D.regalos || [];
    var MARCA = '_regalo_aniversario';
    if (!REGALOS.length) return;

    var grid = document.getElementById('ilevRegaloGrid');
    var caja = modal.querySelector('.ilev-rg-caja');
    var chip = document.getElementById('ilevRegaloChip');
    var trabajando = false;
    var ignorarAdd = false;   /* el add del propio regalo no es "seguir comprando" */

    function clp(centavos) { return '$' + Math.round(centavos / 100).toLocaleString('es-CL'); }

    /* una línea es EL REGALO solo si trae la property invisible */
    function esRegalo(it) { return !!(it.properties && it.properties[MARCA]); }

    function baseElegible(cart) {
      var regalos = (cart.items || []).reduce(function (suma, it) {
        return suma + (esRegalo(it) ? (it.final_line_price || 0) : 0);
      }, 0);
      var total = cart.total_price != null ? cart.total_price : cart.items_subtotal_price;
      return Math.max(0, total - regalos);
    }

    function lineaDelRegalo(cart) {
      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) {
        if (esRegalo(items[i])) return i + 1;   /* /cart/change.js cuenta desde 1 */
      }
      return 0;
    }

    function pintar() {
      grid.innerHTML = REGALOS.map(function (r) {
        return '<div class="ilev-rg-item' + (r.hay ? '' : ' agotado') + '" data-id="' + r.id + '">' +
                 '<span class="ilev-rg-sello" aria-hidden="true">0$</span>' +
                 (r.img ? '<img src="' + r.img + '" alt="' + r.titulo + '" loading="lazy">' : '') +
                 '<div class="ilev-rg-nom">' + r.titulo + '</div>' +
                 '<div class="ilev-rg-baj">' + r.bajada + '</div>' +
                 '<div class="ilev-rg-precio"><s>' + clp(r.precio) + '</s> <b>GRATIS</b></div>' +
                 '<button class="ilev-rg-btn" type="button"' + (r.hay ? '' : ' aria-disabled="true"') + '>' +
                   (r.hay ? r.cta : 'Agotado') +
                 '</button>' +
               '</div>';
      }).join('');
    }

    function abrir() {
      if (modal.classList.contains('abierto')) return;
      pintar();
      modal.classList.add('abierto');
      document.body.style.overflow = 'hidden';
    }

    function cerrar() {
      modal.classList.remove('abierto');
      document.body.style.overflow = '';
      try { sessionStorage.setItem('ilevRegaloCerrado', '1'); } catch (e) {}
    }

    function cerradoAntes() {
      try { return sessionStorage.getItem('ilevRegaloCerrado') === '1'; } catch (e) { return false; }
    }

    /* elegir: sin recargar. Se cierra el pop-up, se repinta el carrito
       con el regalo adentro y se abre el panel: el pago queda a un clic. */
    function elegir(variantId) {
      if (trabajando) return;
      trabajando = true;
      ignorarAdd = true;
      caja.classList.add('ilev-rg-cargando');
      var props = {};
      props[MARCA] = 'Regalo ILEV';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
      })
      .then(function () {
        try { sessionStorage.setItem('ilevRegaloCerrado', '1'); } catch (e) {}
        modal.classList.remove('abierto');
        document.body.style.overflow = '';
        caja.classList.remove('ilev-rg-cargando');
        trabajando = false;
        chip.hidden = true;
        abrirCarrito();
      })
      .catch(function () {
        trabajando = false;
        ignorarAdd = false;
        caja.classList.remove('ilev-rg-cargando');
      });
    }

    function abrirCarrito() {
      if (typeof window.refreshCart === 'function') window.refreshCart();
      setTimeout(function () {
        var d = document.getElementById('site-cart-sidebar');
        if (!d || typeof d.show !== 'function') return;
        if (!window.inertElems) window.inertElems = [];
        try { if (!document.body.classList.contains('sidebar-opened')) d.show(); } catch (e) {}
      }, 450);
    }

    /* el carrito bajó del umbral: el regalo se va */
    function retirar(linea) {
      if (trabajando) return;
      trabajando = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ line: linea, quantity: 0 })
      })
      .then(function () {
        try { sessionStorage.removeItem('ilevRegaloCerrado'); } catch (e) {}
        trabajando = false;
        if (typeof window.refreshCart === 'function') window.refreshCart();
        else window.location.reload();
      })
      .catch(function () { trabajando = false; });
    }

    /* 28-sep-2026: el pop-up no se abre con la primera lectura. Al armar
       un pack (+ en 2 DÚOs → 3 MESES) el carrito pasa un instante por
       "2 DÚOs + pack" ($199.200) antes de borrar los sueltos, y el pop-up
       aparecía medio segundo y se cerraba. Ahora espera a que el carrito
       se quede quieto y vuelve a leerlo: abre solo si el total FINAL
       sigue sobre el umbral. */
    var tAbrir = null;
    function confirmarYAbrir() {
      clearTimeout(tAbrir);
      tAbrir = setTimeout(function () {
        if (trabajando || espera || enVuelo) { confirmarYAbrir(); return; }
        pedir().then(function (c2) {
          if (baseElegible(c2) >= UMBRAL && !lineaDelRegalo(c2)) {
            chip.hidden = false;
            if (!cerradoAntes()) abrir();
          }
        }).catch(function () {});
      }, 900);
    }

    function revisar(c) {
      if (trabajando) return;
      (c ? Promise.resolve(c) : BUS.get()).then(function (cart) {
        var base  = baseElegible(cart);
        var linea = lineaDelRegalo(cart);
        if (base >= UMBRAL) {
          if (linea) { clearTimeout(tAbrir); chip.hidden = true; }
          else confirmarYAbrir();                 /* chip y pop-up, solo con el total final */
        } else {
          clearTimeout(tAbrir);
          chip.hidden = true;
          if (modal.classList.contains('abierto')) cerrar();
          if (linea) retirar(linea);
        }
      }).catch(function () {});
    }

    /* si cerró el pop-up y después sigue comprando, es una intención
       nueva: se le vuelve a ofrecer */
    BUS.on(function (c, info) {
      if (info && info.add) {
        if (ignorarAdd) ignorarAdd = false;
        else { try { sessionStorage.removeItem('ilevRegaloCerrado'); } catch (e) {} }
      }
      revisar(c);
    });

    /* regalo agotado: el botón no agrega y avisa (13-sep). El aviso va en
       el fondo fijo del pop-up, no dentro de la caja (que tiene scroll). */
    var aviso = null, tAviso = 0;
    function avisarAgotado() {
      if (!aviso) {
        aviso = document.createElement('div');
        aviso.className = 'ilev-rg-aviso';
        aviso.setAttribute('role', 'status');
        aviso.setAttribute('aria-live', 'polite');
        modal.appendChild(aviso);
      }
      aviso.textContent = 'Este regalo se agotó. Elige uno de los otros 🎁';
      aviso.classList.add('visible');
      clearTimeout(tAviso);
      tAviso = setTimeout(function () { aviso.classList.remove('visible'); }, 2600);
    }

    grid.addEventListener('click', function (e) {
      var item = e.target.closest('.ilev-rg-item');
      if (!item) return;
      if (item.classList.contains('agotado')) { e.preventDefault(); avisarAgotado(); return; }
      elegir(parseInt(item.getAttribute('data-id'), 10));
    });
    chip.addEventListener('click', abrir);
    modal.querySelector('.ilev-rg-x').addEventListener('click', cerrar);
    modal.querySelector('.ilev-rg-saltar').addEventListener('click', cerrar);
    modal.addEventListener('click', function (e) { if (e.target === modal) cerrar(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('abierto')) cerrar();
    });

    /* para abrirlo desde otro botón: window.ILEV_REGALO.abrir() */
    window.ILEV_REGALO = { abrir: abrir, cerrar: cerrar, revisar: revisar, regalos: REGALOS };
    revisar();
  }

  /* =========================================================
     6. CARRITO EN EL HOME ("Confirma tu pedido")
     ========================================================= */
  function iniciarHome() {
    function clp(c) { return '$' + Math.round(c / 100).toLocaleString('es-CL'); }
    function esc(t) { return String(t || '').replace(/[&<>"]/g, function (m) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[m]; }); }
    function foto(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=400';
    }

    function pintar(cart) {
      var items = (cart && cart.items) || [];
      Array.prototype.forEach.call(document.querySelectorAll('[data-ilev-cph]'), function (sec) {
        var lista = sec.querySelector('[data-cph-lista]');
        if (!lista) return;
        if (!items.length) { sec.hidden = true; lista.innerHTML = ''; return; }
        lista.innerHTML = items.map(function (it) {
          var nombre = it.product_title;
          if (it.variant_title && it.variant_title !== 'Default Title') nombre += ' - ' + it.variant_title;

          /* línea GRATIS del regalo: etiqueta propia, "GRATIS" y tachado */
          var pr = it.properties || {};
          var gratis = !!pr._regalo_aniversario;
          var etiqueta = gratis
            ? '<p class="ilev-cph__desc ilev-cph__gratis">🎁 Tu regalo</p>'
            : '';

          /* desglose: precio original tachado y una línea por descuento */
          var conDesc = !gratis && it.final_line_price < it.original_line_price;
          var tachado = it.original_line_price;
          var descs = gratis ? '' : (it.line_level_discount_allocations || []).map(function (d) {
            var tit = (d.discount_application && d.discount_application.title) || 'Descuento';
            return '<p class="ilev-cph__desc">Descuento ' + esc(tit) + ' (−' + clp(d.amount) + ')</p>';
          }).join('');
          if (conDesc && !descs) descs = '<p class="ilev-cph__desc">Descuento (−' + clp(it.original_line_price - it.final_line_price) + ')</p>';

          return '<div class="ilev-cph__item">' +
                   '<div class="ilev-cph__img">' + (it.image ? '<img src="' + esc(foto(it.image)) + '" alt="" loading="lazy">' : '') + '</div>' +
                   '<div class="ilev-cph__txt">' +
                     '<p class="ilev-cph__nom">' + esc(nombre) + '</p>' +
                     '<p class="ilev-cph__cant">Cant. ' + it.quantity + '</p>' +
                     etiqueta + descs +
                   '</div>' +
                   '<div class="ilev-cph__precio">' + (gratis ? 'GRATIS' : clp(it.final_line_price)) +
                     ((conDesc || gratis) && tachado ? '<s class="ilev-cph__orig">' + clp(tachado) + '</s>' : '') +
                   '</div>' +
                 '</div>';
        }).join('');
        sec.hidden = false;
      });
    }

    if (!document.querySelector('[data-ilev-cph]')) {
      /* en el editor la sección puede aparecer después */
      document.addEventListener('shopify:section:load', function () { BUS.get().then(pintar).catch(function () {}); });
      return;
    }
    BUS.on(pintar);
    BUS.get().then(pintar).catch(function () {});
    document.addEventListener('shopify:section:load', function () { BUS.get().then(pintar).catch(function () {}); });
  }


  /* =========================================================
     7. BURBUJA DEL CARRITO EN EL ENCABEZADO  (11-sep-2026)
     sections/ilev-header.liquid escribe el número solo al cargar la
     página: al añadir algo, la carterita no cambiaba hasta refrescar
     (Franco). Acá se repinta con cada cambio del carrito y al volver
     con el botón "atrás" del celular (la página sale de la memoria
     del navegador, con el número viejo).
     ========================================================= */
  function iniciarBurbuja() {
    var links = document.querySelectorAll('.ilev-hd__ic--cart');
    if (!links.length) return;
    function pintar(c) {
      var n = (c && c.item_count) || 0;
      for (var i = 0; i < links.length; i++) {
        var b = links[i].querySelector('.ilev-hd__burbuja');
        if (!b) {
          if (!n) continue;
          /* con el carrito vacío el encabezado no la dibuja: se crea con
             los colores del ajuste "burbuja" del encabezado */
          b = document.createElement('span');
          b.className = 'ilev-hd__burbuja';
          b.style.background = '#b7dde2';
          b.style.color = '#191f2b';
          links[i].appendChild(b);
        }
        b.textContent = n;
        b.hidden = !n;
      }
    }
    BUS.on(pintar);
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) BUS.refresh().then(pintar).catch(function () {});
    });
  }

  function iniciar() {
    iniciarPanel();
    iniciarBarra();
    iniciarRegalo();
    iniciarHome();
    iniciarBurbuja();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
